import React, { FC } from "react"
import "./styles.scss"
import { enumKeys } from "../../../../helpers"
import { Paper, Tabs as MaterialUITabs, Tab } from "@material-ui/core/"

export enum TABS {
  USERS,
  EVENTS,
  COMMUNITIES,
  BADGES,
  GAMES,
}

interface TabsProps {
  onChange: (event: React.ChangeEvent<{}>, value: any) => void
  selectedTab: TABS
}

export const Tabs: FC<TabsProps> = ({ onChange, selectedTab }) => {
  return (
    <div className="tabs-container">
      <Paper square>
        <MaterialUITabs value={selectedTab} onChange={onChange}>
          {enumKeys(TABS).map((tabName: string) => (
            <Tab
              className={TABS[selectedTab] === tabName ? "tab-selected" : "tab"}
              key={tabName}
              label={tabName.toUpperCase()}
            />
          ))}
        </MaterialUITabs>
      </Paper>
    </div>
  )
}
